<template>
   <LoadingPage v-if="isLoading"></LoadingPage>
   <div class="leads-page p-3">
      <!-- ── Page Header ── -->
      <div class="ms-page-header">
         <div class="ms-page-header__content d-flex justify-content-between align-items-center flex-wrap gap-3 w-100">
            <div class="d-flex align-items-center gap-3">
               <div class="ms-page-header__icon">
                  <i class="fa-solid fa-users"></i>
               </div>
               <div>
                  <p class="ms-page-header__breadcrumb">Sales Pipeline <span class="ms-breadcrumb-sep">/</span> Leads</p>
                  <div class="d-flex align-items-center flex-wrap gap-3 mt-1">
                     <h1 class="ms-page-header__title">Leads</h1>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="card">
         <div class="card-body m-2">
         <div class="row p-2 align-items-center">
            <div class="col-12 col-lg-4 mb-2 mb-lg-0">
               <input v-model.trim="search" type="text" class="form-control form-control-sm"
                  placeholder="🔍 Search organisation, contact name, email or phone...."
                  style="border-radius:8px; height: 40px; font-size: 14px; font-family: 'Roboto', sans-serif; font-weight: 400;"
                  @keyup="onSearch()" />
            </div>

            <div class="col-12 col-lg-auto d-flex mb-2 mb-lg-0 gap-2">
               <button type="button" class="btn-primary-gradient"
                  style="font-size: 14px; height: 40px; padding: 0 1.5rem; display: inline-flex; align-items: center; justify-content: center; gap: 6px;"
                  data-bs-toggle="modal" data-bs-target="#leadForm" @click="onButtonClick('create', '')">
                  <i class="fa-solid fa-plus me-1"></i> Create Lead
               </button>

               <button v-if="this.$store.getters['auth/canExportLeads']" type="button" class="btn-ghost-secondary"
                  style="font-size: 14px; height: 40px; padding: 0 1.5rem; display: inline-flex; align-items: center; justify-content: center; gap: 6px;"
                  @click="exportLeadsToCSV()" :disabled="isLoading">
                  <i class="fa-solid fa-file-csv me-1"></i> Export CSV
               </button>
            </div>

            <div class="col-12 col-lg d-flex flex-wrap justify-content-lg-end align-items-center">


               <div class="d-flex align-items-center me-3 mb-2 mb-md-0">
                  <span class="p-2 filterTitle">Sort by:</span>
                  <select v-model="sortBy" class="form-select shadow-none filterOptions bordered-select">
                     <option v-for="sortBy in sortByList" :value="sortBy.value" :key="sortBy.value">{{ sortBy.text }}
                     </option>
                  </select>
               </div>

               <div class="d-flex align-items-center me-3 mb-2 mb-md-0">
                  <span class="p-2 filterTitle">Rows per page:</span>
                  <select v-model="pagination.pageSize"
                     class="form-select form-select-sm shadow-none filterOptions bordered-select" style="width: auto;">
                     <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{ row.text }}
                     </option>
                  </select>
               </div>

               <div class="pagination">
                  <button @click="previousPage()" :disabled="this.pagination.page == 1" class="pagination-arrow">
                     <i class="fa fa-chevron-left"></i>
                  </button>
                  <span class="pagination-label">
                     <strong>{{ paginationLabel }}</strong> of {{ this.pagination.totalItems }}
                  </span>
                  <button @click="nextPage()"
                     :disabled="this.pagination.page == this.pagination.totalPages || this.pagination.totalItems == 0"
                     class="pagination-arrow">
                     <i class="fa fa-chevron-right"></i>
                  </button>
               </div>
            </div>
         </div>
         <!-- Filters Section -->
         <div class="row p-2 pt-0 align-items-center">
            <div class="col-12 d-flex flex-wrap align-items-center gap-2">
               <!-- Status Filter Dropdown -->
               <div class="dropdown">
                  <button type="button" class="btn custom-filter-dropdown-btn btn-sm fw-bold"
                     style="height: 35px; border-radius: 8px !important; display: inline-flex; align-items: center;"
                     data-bs-toggle="dropdown" aria-expanded="false">
                     Status
                     <i class="fa-solid fa-filter ms-2" style="font-size: 12px; color: #00A0C1;"></i>
                     <span v-if="statusFilter.length > 0" class="badge ms-2 rounded-pill text-white" style="font-size: 10px; background-color: #00A0C1 !important;">
                        {{ statusFilter.length }}
                     </span>
                  </button>
                  <div class="dropdown-menu p-2" style="min-width: 220px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" @click.stop>
                     <div class="d-flex flex-column gap-2 w-100" style="max-height: 250px; overflow-y: auto;">
                        <div v-for="opt in leadStatusTypes" :key="opt.id" class="d-flex align-items-center mb-1">
                           <label class="d-flex align-items-center cursor-pointer mb-0 w-100">
                              <input class="custom-checkbox-input" type="checkbox" :id="'lead-status-' + opt.id" :value="opt.id" v-model="statusFilter" style="pointer-events: auto;">
                              <span class="custom-checkbox"></span>
                              <span class="ms-2 select-none" style="font-size: 14px; font-weight: 500; color: #495057;">{{ opt.display_name }}</span>
                           </label>
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Priority Filter Dropdown -->
               <div class="dropdown">
                  <button type="button" class="btn custom-filter-dropdown-btn btn-sm fw-bold"
                     style="height: 35px; border-radius: 8px !important; display: inline-flex; align-items: center;"
                     data-bs-toggle="dropdown" aria-expanded="false">
                     Priority
                     <i class="fa-solid fa-filter ms-2" style="font-size: 12px; color: #00A0C1;"></i>
                     <span v-if="priorityFilter.length > 0" class="badge ms-2 rounded-pill text-white" style="font-size: 10px; background-color: #00A0C1 !important;">
                        {{ priorityFilter.length }}
                     </span>
                  </button>
                  <div class="dropdown-menu p-2" style="min-width: 220px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" @click.stop>
                     <div class="d-flex flex-column gap-2 w-100" style="max-height: 250px; overflow-y: auto;">
                        <div v-for="opt in leadPriorityTypes" :key="opt.id" class="d-flex align-items-center mb-1">
                           <label class="d-flex align-items-center cursor-pointer mb-0 w-100">
                              <input class="custom-checkbox-input" type="checkbox" :id="'lead-priority-' + opt.id" :value="opt.id" v-model="priorityFilter" style="pointer-events: auto;">
                              <span class="custom-checkbox"></span>
                              <span class="ms-2 select-none" style="font-size: 14px; font-weight: 500; color: #495057;">{{ opt.display_name }}</span>
                           </label>
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Lead Type Filter Dropdown -->
               <div class="dropdown me-1">
                  <button type="button" class="btn custom-filter-dropdown-btn btn-sm fw-bold"
                     style="height: 35px; border-radius: 8px !important; display: inline-flex; align-items: center;"
                     data-bs-toggle="dropdown" aria-expanded="false">
                     Type
                     <i class="fa-solid fa-filter ms-2" style="font-size: 12px; color: #00A0C1;"></i>
                     <span v-if="typeFilter.length > 0" class="badge ms-2 rounded-pill text-white" style="font-size: 10px; background-color: #00A0C1 !important;">
                        {{ typeFilter.length }}
                     </span>
                  </button>
                  <div class="dropdown-menu p-2" style="min-width: 220px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" @click.stop>
                     <div class="d-flex flex-column gap-2 w-100" style="max-height: 250px; overflow-y: auto;">
                        <div v-for="opt in leadTypeList" :key="opt.id" class="d-flex align-items-center mb-1">
                           <label class="d-flex align-items-center cursor-pointer mb-0 w-100">
                              <input class="custom-checkbox-input" type="checkbox" :id="'lead-type-' + opt.id" :value="opt.id" v-model="typeFilter" style="pointer-events: auto;">
                              <span class="custom-checkbox"></span>
                              <span class="ms-2 select-none" style="font-size: 14px; font-weight: 500; color: #495057;">{{ opt.display_name }}</span>
                           </label>
                        </div>
                     </div>
                  </div>
               </div>

               

               
               <!-- Filter Settings Button -->
               <div class="d-flex align-items-center ms-2 me-2">
                  <button @click="showFilterSettingsModal = true" class="btn-ghost-secondary d-flex align-items-center gap-2" style="padding: 6px 14px; font-size: 13.5px; height: 35px;">
                     <i class="fa-solid fa-sliders"></i>
                     Filter Settings
                  </button>
               </div>

               <div v-if="statusFilter.length > 0 || priorityFilter.length > 0 || typeFilter.length > 0" class="d-flex flex-wrap gap-2 align-items-center ms-3">
                  <span class="small text-muted fw-bold">Active Filters:</span>
                  <!-- Status Chips -->
                  <span v-for="val in statusFilter" :key="'status-' + val" class="badge bg-info text-white p-2 d-inline-flex align-items-center gap-1" style="border-radius: 20px; font-size: 12px; font-weight: 500; background-color: #00A0C1 !important;">
                     {{ getStatusDisplayName(val) }}
                     <i class="fa-solid fa-xmark cursor-pointer ms-1" style="font-size: 10px;" @click="removeStatusFilter(val)"></i>
                  </span>
                  <!-- Priority Chips -->
                  <span v-for="val in priorityFilter" :key="'priority-' + val" class="badge bg-info text-white p-2 d-inline-flex align-items-center gap-1" style="border-radius: 20px; font-size: 12px; font-weight: 500; background-color: #00A0C1 !important;">
                     {{ getPriorityDisplayName(val) }}
                     <i class="fa-solid fa-xmark cursor-pointer ms-1" style="font-size: 10px;" @click="removePriorityFilter(val)"></i>
                  </span>
                  <!-- Lead Type Chips -->
                  <span v-for="val in typeFilter" :key="'type-' + val" class="badge bg-info text-white p-2 d-inline-flex align-items-center gap-1" style="border-radius: 20px; font-size: 12px; font-weight: 500; background-color: #00A0C1 !important;">
                     {{ getTypeDisplayName(val) }}
                     <i class="fa-solid fa-xmark cursor-pointer ms-1" style="font-size: 10px;" @click="removeTypeFilter(val)"></i>
                  </span>
                  <button type="button" class="btn btn-link btn-sm text-decoration-none p-0 ms-2" style="font-size: 12px; color: #00A0C1;" @click="clearFilter()">Clear All</button>
               </div>
            </div>
         </div>

         <div class="row p-2">
            <table class="table align-middle mainTable">

               <thead class="align-middle">
                  <tr>
                     <th scope="col" v-for="header in headers" :key="header.value">{{ header.text }}</th>
                  </tr>
               </thead>

               <TableEmptyState
                  v-if="this.pagination.totalItems <= 0"
                  :colspan="headers.length"
                  icon="fa-solid fa-users"
                  title="No Leads Found"
                  description="Your leads pipeline is currently empty. Create your first lead to start tracking potential clients and proposals."
                  action-text="Create Lead"
                  action-icon="fa-solid fa-plus"
                  :is-filtered="isFiltered"
                  filtered-title="No Matching Leads Found"
                  filtered-description="No leads match your current search query or active filter criteria. Try adjusting or clearing your filters."
                  clear-filters-text="Reset Filters & Search"
                  @action="openCreateLeadModal"
                  @clear-filters="clearAllFiltersAndSearch"
               />

               <tbody v-else>
                  <tr v-for="(lead) in leads" :key="lead.id" class="clickable-row">
                      <td @click="onButtonClick('view', lead.id)" data-bs-toggle="offcanvas"
                         data-bs-target="#leadSidebar" aria-controls="leadSidebar">{{ formatDate(lead.date_created) }}
                      </td>
                      <td @click="onButtonClick('view', lead.id)" data-bs-toggle="offcanvas"
                         data-bs-target="#leadSidebar" aria-controls="leadSidebar">
                         {{ (lead.first_name || lead.last_name) ? ((lead.first_name || '') + ' ' + (lead.last_name || '')).trim() : lead.organisation_name }}
                         <span v-if="lead.is_test_data" class="spark-pill-badge spark-pill-badge--test-only ms-2"><i class="fa-solid fa-vial"></i> Test Data</span>
                         <span v-if="!lead.assigned_user_id || lead.assigned_user_id === 0" class="spark-pill-badge spark-pill-badge--unsent-edits ms-2" title="No BDM assigned to this lead. Click to assign a BDM in details.">
                            <i class="fa-solid fa-triangle-exclamation"></i> No BDM
                         </span>
                      </td>
                      <td @click="onButtonClick('view', lead.id)" data-bs-toggle="offcanvas"
                         data-bs-target="#leadSidebar" aria-controls="leadSidebar">
                         <div class="d-flex flex-column">
                             <div class="d-flex align-items-center flex-wrap gap-1">
                                <span>{{ lead.organisation_name || '-' }}</span>
                               <!-- Auth Synced -->
                               <span v-if="(lead.organisation && lead.organisation.is_auth_synced) || lead.is_auth_synced" class="spark-pill-badge spark-pill-badge--synced ms-1" :title="'Synced with Auth' + ((lead.organisation && lead.organisation.auth_organisation_name) ? ': ' + lead.organisation.auth_organisation_name : '')">
                                  <i class="fas fa-sync-alt"></i> Auth Synced
                               </span>
                               <!-- Manually Linked -->
                               <span v-else-if="(lead.organisation && lead.organisation.has_auth_organisation == 1) || lead.has_auth_organisation == 1" class="spark-pill-badge spark-pill-badge--linked ms-1" :title="'Manually Linked to Auth' + ((lead.organisation && lead.organisation.auth_organisation_name) ? ': ' + lead.organisation.auth_organisation_name : (lead.auth_organisation_name ? ': ' + lead.auth_organisation_name : ''))">
                                  <i class="fas fa-link"></i> Manually Linked
                               </span>
                               <!-- Marked for Creation -->
                               <span v-else-if="(lead.organisation && lead.organisation.has_auth_organisation == 2) || lead.has_auth_organisation == 2" class="spark-pill-badge spark-pill-badge--sent ms-1" title="Marked for creation in Auth">
                                  <i class="fas fa-clock"></i> Marked
                               </span>
                             </div>
                             <small v-if="getFormerLeadOrgName(lead)" class="text-muted fst-italic" style="font-size: 0.73rem;" :title="'Original Lead Organisation Name: ' + getFormerLeadOrgName(lead)">
                                <i class="fa-solid fa-history me-1"></i> Formerly: {{ getFormerLeadOrgName(lead) }}
                             </small>
                          </div>
                      </td>
                      <td @click="onButtonClick('view', lead.id)" style="color: #00A0C1" data-bs-toggle="offcanvas"
                         data-bs-target="#leadSidebar" aria-controls="leadSidebar">{{ lead.lead_type_id }}</td>
                      <td style="position:relative; text-align: center;">
                         <span class="spark-pill-badge" :class="[getLeadPriorityBadgeClass(lead.lead_priority_id), { 'not-allowed-cursor': isLeadStatusSpam(lead) }]">
                            <i :class="getLeadPriorityIcon(lead.lead_priority_id)"></i>
                            {{ getPriorityName(lead.lead_priority_id) }}
                         </span>

                         <select v-if="!isLeadStatusSpam(lead)" class="form-select table-select-priority shadow-none" v-model="lead.lead_priority_id"
                            @focus="$refs.popover.closePopover"
                            @change="updateLeadPriority($event, lead.id, lead.lead_priority_id)" data-bs-toggle="popover"
                            tabindex="-1">

                            <option v-for="priority in leadPriorityTypes" :key="priority.id" :value="priority.id">
                               {{ priority.display_name }}
                            </option>

                         </select>
                      </td>
                      <td style="position:relative; text-align: center;">
                         <span class="spark-pill-badge" :class="getLeadStatusBadgeClass(lead.lead_status_id)">
                            <i :class="getLeadStatusIcon(lead.lead_status_id)"></i>
                            {{ getStatusDisplayName(lead.lead_status_id) }}
                         </span>

                         <select class="form-select table-select-status shadow-none" v-model="lead.lead_status_id"
                            @focus="$refs.popover.closePopover"
                            @change="leadStatusChange($event, lead.id, lead.lead_status_id)" data-bs-toggle="popover"
                            tabindex="-1">
                            <option v-for="status in leadStatusTypes" :key="status.id" :value="status.id"
                               :disabled="getLeadStatusId('ProposalSent') == status.id">
                               {{ status.display_name }}
                            </option>
                         </select>
                      </td>

                      <td>
                         <div class="action-button-container">
                            <button type="button" class="btn-svg-icon position-relative"
                               :disabled="!allowedStatusIds.includes(lead.lead_status_id) || !lead.assigned_user_id || lead.assigned_user_id === 0"
                               :title="(!lead.assigned_user_id || lead.assigned_user_id === 0) ? 'Cannot create proposal: BDM not assigned' : 'Click to create proposal'" @click="openProposalModal(lead.id, lead)">
                               <img src="@/assets/img/icons/createproposal.svg" alt="Create Proposal" class="icon-svg" :style="(!lead.assigned_user_id || lead.assigned_user_id === 0) ? 'filter: grayscale(1); opacity: 0.4;' : ''" />
                               <span v-if="lead.lead_proposals && lead.lead_proposals.length > 0"
                                  class="position-absolute top-0 start-100 translate-middle" style="color: #00A54F;">
                                  <span class="fa fa-circle-check"></span>
                                  <span class="visually-hidden">has created proposal</span>
                                </span>
                            </button>

                            <button type="button" class="btn-svg-icon position-relative" data-bs-toggle="modal"
                               data-bs-target="#leadProposals" title="Click to view/upload legacy proposals"
                               @click="onButtonClick('proposal', lead.id)">
                               <img src="@/assets/img/icons/upload_proposal.svg" alt="Upload Legacy Proposal"
                                  class="icon-svg" />
                               <span v-if="lead.has_uploaded_proposal" class="position-absolute top-0 start-100
                                  translate-middle" style="color: #00A54F;">
                                  <span class="fa fa-circle-check"></span>
                                  <span class="visually-hidden">has uploaded proposal</span>
                               </span>
                            </button>

                            <button type="button" class="btn-svg-icon" title="View Client Proposal Page"
                               :disabled="lead.lead_proposals == undefined || lead.lead_proposals.length == 0"
                               @click="onButtonClick('preview', lead.lead_proposals)">
                               <img src="@/assets/img/icons/Landingpage.svg" alt="Preview Proposal" class="icon-svg" />
                            </button>

                            <button v-if="lead.organisation_uuid || (lead.organisation && lead.organisation.uuid)" type="button" class="btn-action-unlink"
                               :disabled="isUnlinkDisabled(lead)"
                               :title="getUnlinkTooltip(lead)"
                               :style="isUnlinkDisabled(lead) ? 'opacity: 0.4; cursor: not-allowed;' : ''"
                               @click="unlinkOrganisationConfirm(lead.uuid || lead.id, lead)">
                               <i class="fas fa-unlink" style="font-size: 14px;"></i>
                            </button>
                            <button v-else type="button" class="btn-action-link"
                               :disabled="isAuthSynced(lead)"
                               :title="isAuthSynced(lead) ? 'Synced Auth Organisations cannot be modified' : 'Link Organisation'"
                               :style="isAuthSynced(lead) ? 'opacity: 0.4; cursor: not-allowed;' : ''"
                               @click="openLinkOrgModal(lead)">
                               <i class="fas fa-link" style="font-size: 14px;"></i>
                            </button>

                            <button type="button" class="btn-svg-icon" title="View/Edit Lead"
                               @click="onButtonClick('view', lead.id)" data-bs-toggle="offcanvas"
                               data-bs-target="#leadSidebar" aria-controls="leadSidebar">
                               <img src="@/assets/img/icons/universal_edit.svg" alt="View/Edit" class="icon-svg" />
                            </button>

                            <button type="button" class="btn-svg-icon btn-svg-icon--delete"
                                :title="isAuthSynced(lead) ? 'This lead is synchronized from the Auth service and cannot be deleted.' : (lead.lead_proposals && lead.lead_proposals.length > 0 ? 'Leads with attached proposals cannot be deleted.' : 'Click to delete')"
                                :disabled="(lead.lead_proposals && lead.lead_proposals.length > 0) || isAuthSynced(lead)"
                                @click="onButtonClick('delete', lead.id)">
                                <img src="@/assets/img/icons/universal_delete.svg" alt="Delete" class="icon-svg" />
                            </button>
                         </div>
                      </td>
                   </tr>
                </tbody>
            </table>
         </div>

      </div>
   </div>

   <div class="modal fade modal-blur" id="leadForm" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static" ref="leadForm"
      style="top: 2%;">
      <div class="blur-backdrop"></div>
      <div ref="modalDialogRef" class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lead-form-width">
         <div class="modal-content" style="border-radius: 16px; border: none; box-shadow: 0 5px 15px rgba(0,0,0,0.3); overflow: visible; background-color: #fff;">
            <!-- Always-static Close Button -->
            <button ref="closeModal" type="button" class="close-button-custom" data-bs-dismiss="modal"
               @click="this.$refs.leadFormRef.resetForm()" aria-label="Close">&times;</button>

            <!-- Static Modal Header -->
            <div class="px-4 pt-4 pb-0 text-start">
               <h5 class="modal-title-custom" style="color: #364A63; font-weight: bold; font-size: 1.25rem;">Create Lead</h5>
               <hr style="margin-top: 1rem; margin-bottom: 0.5rem; border-color: #dee2e6;">
            </div>

            <div class="modal-body px-4 pb-4 pt-2">
               <LeadForm ref="leadFormRef" @onSubmit="init" />
            </div>
         </div>
      </div>
   </div>
   <div class="modal fade" id="leadProposals" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static"
      ref="leadProposalsModalRef" style="top: 2%">
      <div ref="leadProposalModalDialogRef" class="modal-dialog modal-dialog-scrollable modal-lg">
         <div class="modal-content">
            <div class="modal-header d-flex justify-content-between align-items-start">
               <div class="d-flex align-items-start">
                  <h3 class="modal-title" style="color:#f4fbff"><strong> Proposals </strong></h3>
               </div>
               <div class="d-flex align-items-end">
                  <button ref="closeLeadProposalModal" type="button" class="btn-close" data-bs-dismiss="modal"
                     aria-label="Close" @click="this.$refs.leadProposalsRef.resetForm()"></button>
               </div>
            </div>
            <Proposal ref="leadProposalsRef" @onUpdate="init" @onClose="init"
               :isProposalSentStatus="isLeadStatusProposalSent" />
         </div>
      </div>
   </div>
   <div class="modal fade modal-blur" id="leadVertexProposals" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static"
      ref="leadVertexProposalsModalRef" style="top: 2%">
      <div class="blur-backdrop"></div>
      <div ref="leadVertexProposalModalDialogRef" class="modal-dialog modal-dialog-scrollable modal-custom-width">
         <div class="modal-content" style="border-radius: 16px; border: none; box-shadow: 0 10px 30px rgba(0,0,0,0.25); background-color: #fff; min-height: 600px; max-height: 92vh;">
            <!-- Always-static Close Button -->
            <button ref="closeLeadVertexProposalModal" type="button" class="close-button-custom" @click="closeProposalModal" aria-label="Close">&times;</button>

            <!-- Static Modal Header -->
            <div class="px-4 pt-4 pb-0 text-start">
               <h5 class="modal-title-custom" style="color: #364A63; font-weight: bold; font-size: 1.25rem;">Create Proposal</h5>
               <hr style="margin-top: 1rem; margin-bottom: 0.5rem; border-color: #dee2e6;">
            </div>

            <div class="modal-body px-4 pb-4 pt-2">
              <VertexProposal :lead_id="selectedLeadID" ref="vertexLeadProposalsRef" />
            </div>
         </div>
      </div>
   </div>
   <div class="offcanvas offcanvas-end" tabindex="-1" id="leadSidebar" aria-labelledby="leadSidebar"
      ref="leadSidebarRef" style="width:700px">
      <router-view @onSubmit="getLeadsList()"></router-view>
   </div>
   <div id="popover" class="d-none" role="tooltip">
      <Popover ref="popover" @cancelChange="getLeadsList()" @onUploadProposal="toggleProposalUpload" />
   </div>
   <div class="modal fade" id="leadActivityModal" ref="leadActivityModalRef" tabindex="-1">
      <div class="modal-dialog modal-dialog-scrollable">
         <div class="modal-content">
            <div class="modal-header">
               <h5 class="modal-title">Activity Timeline</h5>
               <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
               <LeadNotesForm ref="leadNotesFormRef" />
            </div>
         </div>
      </div>
   </div>

   <ConfirmModal
       v-model="showConfirmModal"
       :title="confirmModalTitle"
       :message="confirmModalMessage"
       @confirm="onConfirmAction"
    />

    <!-- ── Link Organisation Modal ── -->
    <Transition name="lead-modal-fade">
       <div v-if="showLinkOrgModal" class="lead-modal-overlay" @click.self="closeLinkOrgModal">
          <div class="lead-modal">
             <div class="lead-modal__header">
                <h5 class="lead-modal__title"><i class="fas fa-link" style="color: #00A0C1;"></i> Link to Organisation</h5>
                <button type="button" @click="closeLinkOrgModal" class="lead-modal__close">&times;</button>
             </div>
             <div class="lead-modal__divider"></div>
             <form @submit.prevent="confirmLinkOrg" class="lead-modal__body">
                <div class="lead-form-group">
                   <label class="lead-form-label">
                      Select an organisation to link to <strong>{{ leadToLink?.organisation_name || (leadToLink?.first_name ? leadToLink?.first_name + ' ' + leadToLink?.last_name : '') }}</strong> <span class="lead-required">*</span>
                   </label>
                   <select class="lead-form-input" v-model="selectedOrgUuid" required>
                      <option disabled value="">- Select Organisation -</option>
                      <option v-for="org in organisationsList" :key="org.id || org.uuid" :value="org.id || org.uuid">
                         {{ org.name }}
                      </option>
                   </select>
                </div>
                <div class="lead-modal__actions">
                   <button type="button" class="lead-btn lead-btn--ghost" @click="closeLinkOrgModal">Cancel</button>
                   <button type="submit" class="lead-btn lead-btn--primary" :disabled="!selectedOrgUuid">
                      <i class="fas fa-link me-1"></i> Link Organisation
                   </button>
                </div>
             </form>
          </div>
       </div>
    </Transition>

     <!-- ── Filter Settings Modal ── -->
     <Transition name="lead-modal-fade">
        <div v-if="showFilterSettingsModal" class="lead-modal-overlay" @click.self="showFilterSettingsModal = false">
           <div class="lead-modal" style="max-width: 450px;">
              <div class="lead-modal__header">
                 <h5 class="lead-modal__title"><i class="fas fa-sliders"></i> Filter Settings</h5>
                 <button type="button" @click="showFilterSettingsModal = false" class="lead-modal__close">&times;</button>
              </div>
              <div class="lead-modal__divider"></div>
              <div class="lead-modal__body">
                 <!-- Exclude Test Data Switch -->
                 <div class="d-flex align-items-center justify-content-between mb-4">
                    <div>
                       <h6 class="mb-0" style="font-weight: 600; color: #2D3748;">Exclude Test Data</h6>
                       <small class="text-muted">Hide leads marked as test data</small>
                    </div>
                    <div class="form-check form-switch mb-0" style="padding-left: 0;">
                       <input v-model="excludeTestData" type="checkbox" class="form-check-input custom-switch-input mb-0" id="modalExcludeTestDataSwitch" style="cursor: pointer; width: 2.5em; height: 1.25em; margin-left: 0;">
                    </div>
                 </div>

                 <!-- Exclude Spam, Lost, Cold & Test Only Switch -->
                 <div class="d-flex align-items-center justify-content-between mb-3">
                    <div>
                       <h6 class="mb-0" style="font-weight: 600; color: #2D3748;">Exclude Spam, Lost, Cold & Test Only</h6>
                       <small class="text-muted">Hide leads with these status classifications</small>
                    </div>
                    <div class="form-check form-switch mb-0" style="padding-left: 0;">
                       <input v-model="excludeStatuses" type="checkbox" class="form-check-input custom-switch-input mb-0" id="modalExcludeStatusesSwitch" style="cursor: pointer; width: 2.5em; height: 1.25em; margin-left: 0;">
                    </div>
                 </div>

                 <div class="lead-modal__actions mt-4">
                    <button type="button" class="lead-btn lead-btn--primary w-100" @click="showFilterSettingsModal = false">Apply Filters</button>
                 </div>
              </div>
           </div>
        </div>
     </Transition>
   </div>
</template>

<script>
import { Offcanvas } from 'bootstrap';
import LeadForm from '@/components/Leads/LeadForm.vue';
import LeadNotesForm from '@/components/Leads/LeadNotesForm.vue';
import Proposal from '@/components/Proposals/Proposal.vue';
import VertexProposal from '@/components/Proposals/VertexProposal.vue';
import Popover from '@/components/Leads/Popover.vue';
import moment from "moment";
import { debounce } from '@/plugins/helper.js'

import { Modal } from 'bootstrap';
import LoadingPage from '@/components/Utilities/vertex-loading.vue'
import TableEmptyState from '@/components/Utilities/TableEmptyState.vue'

// const NO_AUTH_ORG = 0
const HAS_EXISTING_AUTH_ORG = 1
const MARKED_FOR_AUTH_CREATION = 2

export default {

   components: {
      LeadForm,
      LeadNotesForm,
      Proposal,
      Popover,
      VertexProposal,
      LoadingPage,
      TableEmptyState
   },

   data() {
      return {
         headers: [
            { text: "Date Created", value: "dateCreated" },
            { text: "Lead Name", value: "leadName" },
            { text: "Organisation", value: "organisation" },
            { text: "Type", value: "leadType" },
            { text: "Priority", value: "priority" },
            { text: "Status", value: "leadStatus" },
            { text: "Action", value: "action" },
         ],
         search: "",
         selectedLeadID: "",
         leadVertexProposalsModal: null,
         leadActivityModalInstance: null,
         leads: [],
         pagination: {
            pageSize: 10,
            page: 1,
            totalItems: 0,
            totalPages: 1,
         },
         rowsPerPageList: [
            { text: "5", value: 5 },
            { text: "10", value: 10 },
            { text: "20", value: 20 },
         ],
         sortByList: [
            { text: "Newest", value: "id_desc" },
            { text: "Oldest", value: "id_asc" },
            { text: "Lead Name", value: "lead_name" },
            { text: "Priority", value: "priority" },
            { text: "Status", value: "status" },
         ],
         statusFilter: [],
         priorityFilter: [],
         typeFilter: [],
         activeTab: 'Lead',
         excludeTestData: true,
         showFilterSettingsModal: false,
         excludeStatuses: true,
         sortBy: "id_desc",
         sorting: {
            field: "id",
            order: "desc",
            filter: "none"
         },
         isEditing: false,
         debounceFn: null,
         leadStatusTypes: [],
         leadStatusTypesFilter: [],
         leadPriorityTypes: [],
         leadTypeList: [],
         isLeadStatusProposalSent: false,
         totalProposals: 0,
         markedForAuthCreationOption: {
            id: 'forCreationInAuth',
            name: 'Marked for creation in Auth'
         },
         authOrganisationsList: [],
         isViewSpamOnly: false,

         isLoading: false,
          colorForPriority: {
             'high': '#EB1C24',
             'medium': '#FFB300',
             'low': '#00A54F',
             'not_applicable': '#6C757D',
             'notapplicable': '#6C757D'
          },
         allowedStatusIds: [],
         showConfirmModal: false,
         confirmModalTitle: '',
         confirmModalMessage: '',
         pendingCharityLeadId: null,
         pendingDeleteLeadId: null,
         showLinkAuthOrgModal: false,
         showLinkOrgModal: false,
         leadToLink: null,
         selectedAuthOrg: "",
         selectedOrgUuid: "",
         organisationsList: [],
         pendingUnlinkLeadId: null,
       }
   },

   created() {
      this.init()
      this.debounceFn = debounce(() => this.getLeadsList(), 500)
      this.HAS_EXISTING_AUTH_ORG = HAS_EXISTING_AUTH_ORG
      this.MARKED_FOR_AUTH_CREATION = MARKED_FOR_AUTH_CREATION
   },

   mounted() {
      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('click', this.handleClickOutsideProposal);
      this.leadVertexProposalsModal = new Modal(this.$refs.leadVertexProposalsModalRef);
      this.leadActivityModalInstance = new Modal(this.$refs.leadActivityModalRef);

      if (this.$route.params.id != null) {
         new Offcanvas(this.$refs.leadSidebarRef).show()
         this.onToggleSidebar()
         this.$router.push({ name: 'leads-view', params: { id: this.$route.params.id } })
      }
   },

   beforeUnmount() {
      this.$refs.popover.closePopover(this.$refs.popover);
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('click', this.handleClickOutsideProposal);
   },

   computed: {
      isFiltered() {
         return (this.search && this.search.trim().length > 0) ||
                this.statusFilter.length > 0 ||
                this.priorityFilter.length > 0 ||
                this.typeFilter.length > 0;
      },
      paginationLabel() {
         var start = Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
         var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)
         return start + " - " + end
      },
      currentPage() { return this.pagination.page },
      rowsPerPage() { return this.pagination.pageSize },
      sortItems() { return this.sortBy },
   },

   watch: {
      // Watcher 1: Triggers whenever the page number changes
    currentPage() { 
        this.getLeadsList(); 
    },

    // Watcher 2: Triggers whenever the rows per page dropdown is changed
    rowsPerPage() { 
        // When rows per page changes, we always want to send the user back to Page 1.
        if (this.pagination.page === 1) {
            // If they are ALREADY on Page 1, the currentPage watcher above won't fire (because the value didn't change).
            // So, we must manually fetch the list.
            this.getLeadsList();
        } else {
            // If they are on Page 2 or higher, we just change the page to 1.
            // This will automatically trigger the 'currentPage' watcher above, firing exactly ONE fetch!
            this.pagination.page = 1; 
        }
    },
      sortItems() {
         if (this.sortBy == "id_asc") { this.sorting.field = "id"; this.sorting.order = "asc" }
         else if (this.sortBy == "id_desc") { this.sorting.field = "id"; this.sorting.order = "desc" }
         else if (this.sortBy == "lead_name") { this.sorting.field = "organisation_name"; this.sorting.order = "asc" }
         else if (this.sortBy == "lead_type") { this.sorting.field = "lead_type"; this.sorting.order = "asc" }
         else if (this.sortBy == "priority" || this.sortBy == "status") { this.sorting.field = this.sortBy; this.sorting.order = "" }
         this.sorting.filter = "none"
         this.getLeadsList()
      },
      statusFilter: {
         handler() {
            this.pagination.page = 1
            this.getLeadsList()
         },
         deep: true
      },
      priorityFilter: {
         handler() {
            this.pagination.page = 1
            this.getLeadsList()
         },
         deep: true
      },
      typeFilter: {
         handler() {
            this.pagination.page = 1
            this.getLeadsList()
         },
         deep: true
      },
      excludeTestData() {
         this.pagination.page = 1
         this.getLeadsList()
      },
      excludeStatuses() {
         this.pagination.page = 1
         this.getLeadsList()
      },
   },

   methods: {
      async exportLeadsToCSV() {
         try {
            this.isLoading = true;
            this.$toast.info("Export started. Your file will download shortly.");

            // Build the API path with current filters
            let apiPath = "/leads/export/csv?pageSize=2000&page=1&sort=id&order=desc&classification=Lead";
            if (this.search) apiPath += `&query=${encodeURIComponent(this.search)}`;
            if (this.statusFilter.length > 0) apiPath += `&status=${this.statusFilter.join(",")}`;
            if (this.priorityFilter.length > 0) apiPath += `&priority=${this.priorityFilter.join(",")}`;
            if (this.typeFilter.length > 0) apiPath += `&type=${this.typeFilter.join(",")}`;
            apiPath += `&excludeTestData=${this.excludeTestData}`;
            apiPath += `&excludeStatuses=${this.excludeStatuses}`;

            const response = await this.$axios.get(apiPath, { responseType: 'blob' });

            const blob = new Blob([response.data], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `leads_export.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);

         } catch (error) {
            let errorMessage = "An error occurred during export.";
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error("Export Error Response:", error.response);
                if (error.response.data instanceof Blob && error.response.data.type.includes('json')) {
                    const errorJson = await error.response.data.text();
                    const errorData = JSON.parse(errorJson);
                    if (errorData && errorData.message) {
                        errorMessage = errorData.message;
                    }
                } else if (error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
            } else if (error.request) {
                // The request was made but no response was received
                console.error("Export Error Request:", error.request);
                errorMessage = "No response from server during export.";
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error("Export Error Message:", error.message);
                errorMessage = error.message;
            }
            this.$toast.error(errorMessage);
         } finally {
            this.isLoading = false;
         }
      },

      getFormerLeadOrgName(lead) {
         if (!lead) return '';
         if (lead.original_organisation_name && lead.original_organisation_name !== lead.organisation_name) {
            return lead.original_organisation_name;
         }
         if (lead.organisation && lead.organisation.original_organisation_name && lead.organisation.original_organisation_name !== lead.organisation_name) {
            return lead.organisation.original_organisation_name;
         }
         if (lead.organisation && lead.organisation.pre_link_snapshot) {
            try {
               const snap = typeof lead.organisation.pre_link_snapshot === 'string' ? JSON.parse(lead.organisation.pre_link_snapshot) : lead.organisation.pre_link_snapshot;
               if (snap && snap.original_organisation_name && snap.original_organisation_name !== lead.organisation_name) {
                  return snap.original_organisation_name;
               }
            } catch (e) {
               console.warn("Could not parse pre_link_snapshot:", e);
            }
         }
         return '';
      },

      getUnlinkDisabledReason() {
         return '';
      },
      isUnlinkDisabled() {
         return false;
      },
      getUnlinkTooltip(lead) {
         if (!lead) return '';
         const linkedOrgName = (lead.organisation && lead.organisation.name) ? lead.organisation.name : lead.organisation_name;
         return `Unlink ${linkedOrgName} (restores original lead details)`;
      },
      isAuthSynced(lead) {
         if (!lead) return false;
         return !!(lead.is_auth_synced || lead.has_auth_organisation === 1 || lead.has_auth_organisation === 2 || (lead.organisation && (lead.organisation.is_auth_synced || lead.organisation.has_auth_organisation === 1 || lead.organisation.has_auth_organisation === 2)));
      },
      isClient(lead) {
         if (!lead) return false;
         if (lead.classification === 'Client' || lead.organisation_classification === 'Client') return true;
         if (lead.organisation && lead.organisation.classifications) {
            return lead.organisation.classifications.some(c => (c.classification === 'Client' || c === 'Client'));
         }
         return false;
      },
      openProposalModal(leadId, lead) {
         const hasExistingProposals = lead && lead.lead_proposals && lead.lead_proposals.length > 0;
         const isClientOrg = this.isClient(lead);
         const isSynced = this.isAuthSynced(lead);

         if (isClientOrg && hasExistingProposals && !isSynced) {
            this.$toast.error("Proposals can only be created for Client organisations that are synced with Auth.");
            return;
         }

         if (lead && lead.is_charity) {
            this.pendingCharityLeadId = leadId;
            this.confirmModalTitle = 'Charity Notice';
            this.confirmModalMessage = 'Please be advised that this organisation is a registered charity and differentiated pricing may be required.';
            this.showConfirmModal = true;
         } else {
            this.$refs.vertexLeadProposalsRef.init(leadId)
            this.leadVertexProposalsModal.show();
         }
      },
      onConfirmAction() {
         if (this.pendingCharityLeadId) {
            const leadId = this.pendingCharityLeadId;
            this.pendingCharityLeadId = null;
            if (!leadId) return;
            this.$refs.vertexLeadProposalsRef.init(leadId)
            this.leadVertexProposalsModal.show();
         } else if (this.pendingUnlinkLeadId) {
            const leadId = this.pendingUnlinkLeadId;
            this.pendingUnlinkLeadId = null;
            this.unlinkOrganisation(leadId);
         } else if (this.pendingDeleteLeadId) {
            const leadId = this.pendingDeleteLeadId;
            this.pendingDeleteLeadId = null;
            this.executeDeleteLead(leadId);
         }
      },

      openActivityModal(leadId) {
         this.$refs.leadNotesFormRef.init(leadId);
         this.leadActivityModalInstance.show();
      },

      closeProposalModal() {
         this.leadVertexProposalsModal.hide();
         this.selectedLeadID = null;
      },

      handleClickOutside(event) {
         // Ignore if target no longer in DOM (e.g. dropdown item was clicked and unmounted)
         if (!document.body.contains(event.target)) return;
         // Ignore vue-tel-input dropdown clicks if they somehow escape the dialog check
         if (event.target.closest && (event.target.closest('.vti__dropdown-list') || event.target.closest('.vue-tel-input') || event.target.closest('.multiselect'))) return;

         if (this.$refs.modalDialogRef && !this.$refs.modalDialogRef.contains(event.target) && this.$refs.leadForm.classList.contains('show')) {
            const closeButton = this.$refs.closeModal;
            if (closeButton) {
               this.$refs.leadFormRef.resetForm()
               closeButton.click();
            }
         }
      },

      handleClickOutsideProposal(event) {
         if (!document.body.contains(event.target)) return;
         if (event.target.closest && event.target.closest('.multiselect')) return;
         
         if (this.$refs.leadProposalModalDialogRef && !this.$refs.leadProposalModalDialogRef.contains(event.target) && this.$refs.leadProposalsModalRef.classList.contains('show')) {
            const closeButton = this.$refs.closeLeadProposalModal;
            if (closeButton) closeButton.click();
         }
      },

      init() {
         this.getLeadsList()
         this.getLeadStatusList()
         this.getLeadPriorityList()
         this.getLeadTypeList()
         if (this.$refs.closeModal) this.$refs.closeModal.click();
      },

      onButtonClick(action, id) {
         if (action == "create") this.$refs.leadFormRef.isCreate()
         else if (action == "edit") this.$refs.leadFormRef.isEdit(id)
         else if (action == "delete") {
            const lead = this.leads.find(l => l.id === id);
            if (lead) {
               this.deleteLeadConfirm(lead);
            }
         }
         else if (action == "view") {
            this.onToggleSidebar()
            this.$router.push({ name: 'leads-view', params: { id: id } })
         } else if (action == "proposal") this.$refs.leadProposalsRef.init(id)
         else if (action == "preview") {
            let lead_proposals = id
            let internal_key = lead_proposals[lead_proposals.length - 1].internal_key
            let ukey = lead_proposals[lead_proposals.length - 1].unique_key
            const routeData = this.$router.resolve({ name: 'clientProposal', params: { unique_key: ukey, access_key: internal_key } });
            window.open(routeData.href, '_blank');
         }
      },

      onToggleSidebar() {
         this.$refs.leadSidebarRef.addEventListener('hidden.bs.offcanvas', () => {
            this.$router.push({ name: 'leads' })
         });
      },

      onSearch() {
         this.debounceFn()
         this.pagination.page = 1
      },

      toggleProposalUpload({ id }) {
         this.isLeadStatusProposalSent = true
         this.$refs.leadProposalsRef.showModal(this.$refs.leadProposals)
         this.$refs.leadProposals.addEventListener('hidden.bs.modal', () => { this.isLeadStatusProposalSent = false });
         this.$refs.leadProposalsRef.init(id)
      },

      async getLeadsList() {
         this.isLoading = true
         let apiPath = "/leads?pageSize=" + this.pagination.pageSize + "&page=" + this.pagination.page + "&classification=Lead"

         if (this.sortBy != "dateCreated_desc") {
            apiPath += "&sort=" + this.sorting.field
            if (this.sorting.order != "") apiPath += "&order=" + this.sorting.order
         }

         if (this.statusFilter.length > 0) {
            apiPath += "&status=" + this.statusFilter.join(",")
         }
         if (this.priorityFilter.length > 0) {
            apiPath += "&priority=" + this.priorityFilter.join(",")
         }
         if (this.typeFilter.length > 0) {
            apiPath += "&type=" + this.typeFilter.join(",")
         }
         apiPath += "&excludeTestData=" + this.excludeTestData
         apiPath += "&excludeStatuses=" + this.excludeStatuses

         if (this.search != "") {
            let encodedStr = this.search.replaceAll("+", "%2B")
            apiPath += "&query=" + encodedStr
         }

         await this.$axios.get(apiPath)
            .then((response) => {
               this.leads = response.data.leads

               console.log(this.leads)
               this.pagination.totalItems = response.data.total_items
               this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
               this.isLoading = false
            })
            .catch((error) => {
               this.$toast.error(error.response?.data?.message || "Error fetching leads")
               this.isLoading = false
            })
      },

      formatDate(date) { return moment(date).format("DD-MMM-YYYY") },
      previousPage() { this.pagination.page > 1 ? this.pagination.page -= 1 : '' },
      nextPage() { this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : '' },

      priorityClass(value) {
         let priority = this.leadPriorityTypes.filter((p) => { return p.id == value }).map((e) => e.name)
         return priority.toString().toLowerCase()
      },

      async leadStatusChange(e, leadId, statusId) {
         const specificStatuses = ['Spam', 'test_only', 'PartnerLead', 'Recruitment', 'pr_opportunity'];
         const isSpecific = specificStatuses.some(status => statusId == this.getLeadStatusId(status));
         
         if (isSpecific) {
            let lead = this.leads.find(l => l.id == leadId);
            let naPriority = this.leadPriorityTypes.find(p => p.name === 'not_applicable');
            if (lead && naPriority) lead.lead_priority_id = naPriority.id;
         }

         if (statusId == this.getLeadStatusId('ProposalSent')) {
            await this.$refs.leadProposalsRef.hasUploadedProposal(leadId).then((response) => this.totalProposals = response)
         }
         if (statusId == this.getLeadStatusId('Lost')) this.$refs.popover.showPopover(e.target, leadId, statusId, "lostLead");
         else if (statusId == this.getLeadStatusId('ProposalSent') && this.totalProposals < 1) this.$refs.popover.showPopover(e.target, leadId, statusId, "proposalSent");
         else this.$refs.popover.showPopover(e.target, leadId, statusId, "statusUpdate");
      },

      getLeadStatusId(statusName) {
         return this.leadStatusTypes.filter(e => { return e.name == statusName }).map(e => (e.id)).toString()
      },

      isLeadStatusSpam(lead) {
         const spamStatus = this.leadStatusTypes.find(s => s.name === 'Spam');
         return !!(spamStatus && lead.lead_status_id == spamStatus.id);
      },

      async updateLeadPriority(e, leadId, priorityId) {
         this.$refs.popover.showPopover(e.target, leadId, '', false);
         let lead = { lead_priority_id: priorityId }
         await this.$axios.put("/leads/" + leadId + "/priority", lead)
            .then((response) => {
               if (response.data.success) {
                  this.$toast.success(response.data.message)
                  this.getLeadsList();
               } else this.$toast.error(response.data.message)
            })
            .catch((error) => { this.$toast.error(error.response.data.message) })
      },

      async getLeadStatusList() {
         await this.$axios.get("/categories?name=LeadStatus")
            .then((response) => {
               this.leadStatusTypes = response.data.category.subcategories
               this.leadStatusTypesFilter = response.data.category.subcategories
               this.allowedStatusIds = [
                  this.getLeadStatusId('New'),
                  this.getLeadStatusId('ProposalPending'),
                  this.getLeadStatusId('test_only'),
                  this.getLeadStatusId('TestOnly'),
                  this.getLeadStatusId('PartnerLead'),
                  this.getLeadStatusId('Recruitment'),
                  this.getLeadStatusId('pr_opportunity'),
               ];
            })
            .catch((error) => { this.$toast.error(error.response.data.message) })
      },

      async getLeadPriorityList() {
         await this.$axios.get("/categories?name=LeadPriority")
            .then((response) => { this.leadPriorityTypes = response.data.category.subcategories })
            .catch((error) => { this.$toast.error(error.response.data.message) })
      },

      async getLeadTypeList() {
         await this.$axios.get("/categories?name=LeadType")
            .then((response) => { this.leadTypeList = response.data.category.subcategories })
            .catch((error) => { this.$toast.error(error.response.data.message) })
      },

      async unlinkOrganisation(leadId) {
         let lead = { organisation_uuid: "" }
         await this.$axios.put("/leads/" + leadId + "/organisation", lead)
            .then((response) => {
               if (response.data.success) { this.$toast.success(response.data.message); this.getLeadsList(); }
               else this.$toast.error(response.data.message)
            })
            .catch((error) => { this.$toast.error(error.response?.data?.message || "Failed to unlink organisation") })
      },

      sortedAuthOrganisationsList(leadOrgId) {
         let multiselect = document.querySelectorAll(".multiselect__content-wrapper")
         multiselect.forEach((sel) => sel.scrollTop = 0)
         if (leadOrgId != null && leadOrgId.id > 0) {
            let orgList = this.authOrganisationsList.map((obj) => { return obj })
            let orgIndex = orgList.findIndex(org => org.id == leadOrgId.id)
            let selectedOrg = orgList.filter(org => { return org.id == leadOrgId.id })
            orgList.splice(orgIndex, 1)
            orgList.unshift(selectedOrg[0])
            return orgList
         } else return this.authOrganisationsList
      },

      clearFilter() {
         this.statusFilter = []
         this.priorityFilter = []
         this.typeFilter = []
      },
      clearAllFiltersAndSearch() {
         this.search = '';
         this.statusFilter = [];
         this.priorityFilter = [];
         this.typeFilter = [];
         this.pagination.page = 1;
         this.getLeadsList();
      },
      openCreateLeadModal() {
         this.onButtonClick('create', '');
         const modalEl = document.getElementById('leadForm');
         if (modalEl) {
            const modal = Modal.getOrCreateInstance(modalEl);
            modal.show();
         }
      },
      removeStatusFilter(val) {
         this.statusFilter = this.statusFilter.filter(v => v !== val)
      },
      removePriorityFilter(val) {
         this.priorityFilter = this.priorityFilter.filter(v => v !== val)
      },
      removeTypeFilter(val) {
         this.typeFilter = this.typeFilter.filter(v => v !== val)
      },
      getStatusDisplayName(id) {
         const obj = this.leadStatusTypes.find(o => o.id === id)
         return obj ? obj.display_name : id
      },
      getPriorityDisplayName(id) {
         const obj = this.leadPriorityTypes.find(o => o.id === id)
         return obj ? obj.display_name : id
      },
      getTypeDisplayName(id) {
         const obj = this.leadTypeList.find(o => o.id === id)
         return obj ? obj.display_name : id
      },

      getPriorityColor(priorityId) {
         const priority = this.leadPriorityTypes.find(p => p.id === priorityId);
         if (!priority) return '#6c757d';
         return this.colorForPriority[priority.name.toLowerCase()] || '#6c757d';
      },

      getPriorityName(priorityId) {
         const priority = this.leadPriorityTypes.find(p => p.id === priorityId);
         return priority ? priority.display_name : 'Unknown';
      },

      getLeadPriorityBadgeClass(priorityId) {
         const priority = this.leadPriorityTypes.find(p => p.id === priorityId);
         if (!priority) return 'spark-pill-badge--priority-na';
         const name = (priority.name || '').toLowerCase();
         if (name.includes('high')) return 'spark-pill-badge--priority-high';
         if (name.includes('medium')) return 'spark-pill-badge--priority-medium';
         if (name.includes('low')) return 'spark-pill-badge--priority-low';
         return 'spark-pill-badge--priority-na';
      },

      getLeadPriorityIcon(priorityId) {
         const priority = this.leadPriorityTypes.find(p => p.id === priorityId);
         if (!priority) return 'fa-solid fa-minus';
         const name = (priority.name || '').toLowerCase();
         if (name.includes('high')) return 'fa-solid fa-fire';
         if (name.includes('medium')) return 'fa-solid fa-equals';
         if (name.includes('low')) return 'fa-solid fa-arrow-down';
         return 'fa-solid fa-minus';
      },

      getLeadStatusBadgeClass(statusId) {
         const status = this.leadStatusTypes.find(s => s.id === statusId);
         if (!status) return 'spark-pill-badge--cold';
         const name = status.name || '';
         switch (name) {
            case 'New': return 'spark-pill-badge--new-lead';
            case 'ProposalPending': return 'spark-pill-badge--proposal-pending';
            case 'ProposalSent': return 'spark-pill-badge--proposal-sent';
            case 'ProposalAccepted': return 'spark-pill-badge--proposal-accepted';
            case 'ContractPending': return 'spark-pill-badge--contract-pending';
            case 'Converted': return 'spark-pill-badge--converted';
            case 'Lost': return 'spark-pill-badge--lost';
            case 'Cold': return 'spark-pill-badge--cold';
            case 'Spam': return 'spark-pill-badge--spam';
            case 'test_only': return 'spark-pill-badge--test-only';
            case 'PartnerLead': return 'spark-pill-badge--partner-lead';
            case 'Recruitment': return 'spark-pill-badge--recruitment';
            case 'pr_opportunity': return 'spark-pill-badge--pr-opportunity';
            default: return 'spark-pill-badge--cold';
         }
      },

      getLeadStatusIcon(statusId) {
         const status = this.leadStatusTypes.find(s => s.id === statusId);
         if (!status) return 'fa-solid fa-circle-notch';
         const name = status.name || '';
         switch (name) {
            case 'New': return 'fa-solid fa-sparkles';
            case 'ProposalPending': return 'fa-solid fa-clock';
            case 'ProposalSent': return 'fa-solid fa-paper-plane';
            case 'ProposalAccepted': return 'fa-solid fa-circle-check';
            case 'ContractPending': return 'fa-solid fa-file-contract';
            case 'Converted': return 'fa-solid fa-check-double';
            case 'Lost': return 'fa-solid fa-circle-xmark';
            case 'Cold': return 'fa-solid fa-snowflake';
            case 'Spam': return 'fa-solid fa-ban';
            case 'test_only': return 'fa-solid fa-vial';
            case 'PartnerLead': return 'fa-solid fa-handshake';
            case 'Recruitment': return 'fa-solid fa-user-group';
            case 'pr_opportunity': return 'fa-solid fa-bullhorn';
            default: return 'fa-solid fa-circle-notch';
         }
      },

      async getOrganisationsList() {
         await this.$axios.get("/organisations?pageSize=200")
            .then((response) => {
               this.organisationsList = response.data.organisations || response.data.data || []
            })
            .catch((error) => { this.$toast.error(error.response?.data?.message || "Failed to load organisations") })
      },

      async openLinkOrgModal(lead) {
         this.leadToLink = lead;
         this.selectedOrgUuid = "";
         if (this.organisationsList.length === 0) {
            await this.getOrganisationsList()
         }
         this.showLinkOrgModal = true;
      },

      closeLinkOrgModal() {
         this.showLinkOrgModal = false;
         this.leadToLink = null;
         this.selectedOrgUuid = "";
      },

      async confirmLinkOrg() {
         if (!this.selectedOrgUuid) return;
         
         const leadId = this.leadToLink.uuid || this.leadToLink.id;
         let payload = {
            organisation_uuid: this.selectedOrgUuid
         };
         
         await this.$axios.put("/leads/" + leadId + "/organisation", payload)
            .then((response) => {
               if (response.data.success) { 
                  this.$toast.success(response.data.message); 
                  this.getLeadsList(); 
               }
               else this.$toast.error(response.data.message)
            })
            .catch((error) => { this.$toast.error(error.response?.data?.message || "Failed to link organisation") })
            
         this.closeLinkOrgModal();
      },

      unlinkOrganisationConfirm(leadId, lead) {
         this.pendingUnlinkLeadId = lead.uuid || lead.id || leadId;
         this.confirmModalTitle = 'Unlink Organisation';
         const orgName = (lead.organisation ? lead.organisation.name : lead.organisation_name) || 'the organisation';
         this.confirmModalMessage = `Are you sure you want to unlink ${orgName} from this lead?`;
         this.showConfirmModal = true;
      },

      deleteLeadConfirm(lead) {
         this.pendingDeleteLeadId = lead.uuid || lead.id;
         this.confirmModalTitle = 'Delete Lead';
         if (lead.organisation && !this.isAuthSynced(lead)) {
            const orgName = lead.organisation.name || lead.organisation_name || 'its linked organisation';
            this.confirmModalMessage = `Are you sure you want to delete this lead? This will also delete "${orgName}", which is a linked non-auth synced organisation.`;
         } else {
            this.confirmModalMessage = 'Are you sure you want to delete this lead?';
         }
         this.showConfirmModal = true;
      },

      async executeDeleteLead(leadId) {
         await this.$axios.delete("/leads/" + leadId)
            .then((response) => {
               if (response.data.success) {
                  this.$toast.success(response.data.message)
                  this.getLeadsList();
               } else {
                  this.$toast.error(response.data.message)
               }
            })
            .catch((error) => {
               this.$toast.error(error.response?.data?.message || "Failed to delete lead")
            })
      },
   }

}
</script>

<style>
/* ... (All existing styles from previous response) ... */
.filterTitle {
   font-weight: 500;
   color: #435666;
}

.filterOptions {
   font-weight: 500;
   color: #00A0C1;
}

.bordered-select {
   border: 1px solid #dee2e6 !important;
   border-radius: 8px !important;
   padding-top: 0.25rem;
   padding-bottom: 0.25rem;
   padding-left: 0.75rem;
   height: 35px;
   width: auto;
}

.pagination {
   display: inline-flex;
   align-items: center;
   border: 1px solid #dee2e6;
   border-radius: 8px;
   background-color: #fff;
   overflow: hidden;
   height: 35px;
}

.pagination-label {
   font-size: 0.9rem;
   color: #6c757d;
   font-weight: 500;
   padding: 0 8px;
   white-space: nowrap;
}

.pagination-label strong {
   color: #343a40;
}

.pagination-arrow {
   background-color: transparent;
   border: none;
   cursor: pointer;
   color: #00A0C1;
   font-size: 1rem;
   padding: 8px 12px;
   transition: background-color 0.2s ease;
}

.pagination-arrow:hover:not(:disabled) {
   background-color: #f1f3f5;
}

.pagination-arrow:disabled {
   color: #ced4da;
   cursor: not-allowed;
}

.action-button-container {
   display: flex;
   align-items: center;
   justify-content: center;
   gap: 5px;
}

.btn-svg-icon {
   width: 36px;
   height: 36px;
   border-radius: 50% !important;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   background-color: #e6f7fa;
   color: #00A0C1;
   border: none;
   padding: 0;
   cursor: pointer;
   transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}

.icon-svg {
   width: 30px;
   height: 30px;
   transition: filter 0.15s ease;
}

.icon-svg-fa {
   font-size: 16px;
   color: inherit;
   transition: color 0.15s ease;
}

.btn-svg-icon:hover:not(:disabled) {
   background-color: #00A0C1;
   color: #fff;
   transform: translateY(-1px);
   box-shadow: 0 4px 12px rgba(0, 160, 193, 0.25);
}

.btn-svg-icon:active:not(:disabled) {
   transform: translateY(0);
}

.btn-svg-icon:hover:not(:disabled) .icon-svg {
   filter: brightness(0) invert(1);
}

.btn-svg-icon--delete {
   background-color: #fef2f2;
   color: #ef4444;
}

.btn-svg-icon--delete:hover:not(:disabled) {
   background-color: #ef4444;
   box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
}

.btn-svg-icon:disabled {
   cursor: not-allowed;
   opacity: 0.4;
   transform: none !important;
   box-shadow: none !important;
}

.high {
   color: #EB1C24;
}

.low {
   color: #00A54F;
}

.medium {
   color: #FFB300;
}

.clickable-row {
   cursor: pointer;
}

td {
   padding-top: 0 !important;
   padding-bottom: 0 !important;
}

.table-select {
   padding-left: 5px;
   margin-right: 0;
   cursor: pointer;
   border: none;
   height: 45px;
   width: auto;
}

.table-select:not(.high, .low, .medium) {
   color: #435666;
}

.table-select>option {
   color: #212529;
}

.table-select:not(:hover) {
   background: none;
}

.auth-org-select {
   padding: .375rem 2.25rem .375rem 5px;
   display: block;
   width: auto;
   font-size: 1rem;
   font-weight: 400;
   color: #435666;
   border: none;
   height: 45px;
   background: none;
   min-height: unset;
   text-align: start;
   align-items: center;
}

.auth-org-select .multiselect__tags {
   width: auto;
   height: auto;
   color: #435666;
   border: none;
   padding: .375rem 0 .375rem 0;
}

.auth-org-select .multiselect__placeholder,
.multiselect--active {
   width: auto;
   margin: 0px;
   padding: .375rem 0 .375rem 0;
   color: #435666;
}

.auth-org-select .multiselect__single {
   margin: 0px;
   padding: .375rem 0 .375rem 0;
   line-height: 1;
   width: auto;
}

.auth-org-select .multiselect__input {
   line-height: 1;
   padding: .375rem 0 .375rem 5px;
   margin: 0px;
}

.status-pill {
   display: inline-flex;
   justify-content: center;
   align-items: center;
   min-width: 70px;
   height: 24px;
   padding: 0 10px;
   border-radius: 5px;
   color: white;
   font-size: 12px;
   font-weight: bold;
   text-transform: none;
   white-space: nowrap;
   vertical-align: middle;
   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.not-allowed-cursor {
   cursor: not-allowed;
}

.table-select-priority,
.table-select-status {
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   opacity: 0;
   color: black;
   cursor: pointer;
}

.blur-backdrop {
   position: fixed;
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   backdrop-filter: blur(5px);
   background-color: rgba(0,0,0,0.4);
}

@media (min-width: 768px) {
   .modal-xl {
      width: 90%;
      max-width: 1800px;
   }
}

select option:disabled {
   color: #999;
   background-color: #f5f5f5;
   cursor: not-allowed;
}

.btn-outline-info:focus,
.btn-outline-info:active,
.btn-outline-info.show {
   background-color: #00A0C1 !important;
   color: #ffffff !important;
   border-color: #00A0C1 !important;
}

.btn-outline-info.show .filter-text,
.btn-outline-info.show .filter-icon {
   color: #ffffff !important;
}

.modal-custom-width {
   max-width: 95vw !important;
}
.modal-lead-form-width {
   max-width: 600px !important;
   width: 100% !important;
}
.close-button-custom {
   position: absolute;
   top: 1rem;
   right: 1.5rem;
   font-size: 2rem;
   font-weight: bold;
   line-height: 1;
   color: #888;
   background: none;
   border: none;
   cursor: pointer;
   z-index: 10;
}
.close-button-custom:hover {
   color: #000;
}
.modal-title-custom {
   font-weight: bold;
   font-size: 1.25rem;
   text-align: left;
   margin-bottom: 0;
}

/* ── Link Org Modal Styling ── */
.lead-modal-overlay {
   position: fixed;
   top: 0;
   left: 0;
   width: 100vw;
   height: 100vh;
   background: rgba(15, 23, 42, 0.5);
   backdrop-filter: blur(4px);
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: 1050;
}

.lead-modal {
   background: #fff;
   border-radius: 20px;
   width: 100%;
   max-width: 520px;
   min-width: 340px;
   box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
   overflow: hidden;
   animation: lead-modal-enter 0.25s ease-out;
}

@keyframes lead-modal-enter {
   from {
      opacity: 0;
      transform: translateY(12px) scale(0.98);
   }
   to {
      opacity: 1;
      transform: translateY(0) scale(1);
   }
}

.lead-modal__header {
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 20px 24px 0;
}

.lead-modal__title {
   font-weight: 700;
   font-size: 1.15rem;
   color: #1e293b;
   display: flex;
   align-items: center;
   gap: 8px;
   margin: 0;
}

.lead-modal__title i {
   color: #00A0C1;
}

.lead-modal__close {
   background: none;
   border: none;
   font-size: 1.8rem;
   color: #94a3b8;
   cursor: pointer;
   line-height: 1;
   padding: 0;
   transition: color 0.15s;
}

.lead-modal__close:hover {
   color: #ef4444;
}

.lead-modal__divider {
   height: 1px;
   background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
   margin: 16px 24px 0;
}

.lead-modal__body {
   padding: 20px 24px 24px;
}

.lead-modal__actions {
   display: flex;
   justify-content: flex-end;
   gap: 10px;
   margin-top: 24px;
   padding-top: 16px;
   border-top: 1px solid #f1f5f9;
}

.lead-form-group {
   margin-bottom: 16px;
}

.lead-form-label {
   display: block;
   font-weight: 500;
   font-size: 0.875rem;
   color: #475569;
   margin-bottom: 8px;
}

.lead-required {
   color: #ef4444;
}

.lead-form-input {
   width: 100%;
   padding: 10px 14px;
   border: 1.5px solid #e2e8f0;
   border-radius: 10px;
   font-size: 0.875rem;
   color: #334155;
   background: #fff;
   transition: border-color 0.2s, box-shadow 0.2s;
   outline: none;
}

.lead-form-input:focus {
   border-color: #00A0C1;
   box-shadow: 0 0 0 3px rgba(0, 160, 193, 0.12);
}

.lead-btn {
   padding: 10px 22px;
   border-radius: 10px;
   font-size: 0.875rem;
   font-weight: 600;
   cursor: pointer;
   display: inline-flex;
   align-items: center;
   gap: 6px;
   transition: all 0.2s ease;
   border: none;
}

.lead-btn--primary {
   background: linear-gradient(135deg, #00A0C1, #33b5d1);
   color: #fff;
   box-shadow: 0 2px 8px rgba(0, 160, 193, 0.3);
}

.lead-btn--primary:hover {
   background: linear-gradient(135deg, #008da8, #00A0C1);
   box-shadow: 0 4px 16px rgba(0, 160, 193, 0.4);
   transform: translateY(-1px);
}

.lead-btn--primary:disabled {
   opacity: 0.5;
   cursor: not-allowed;
   transform: none;
}

.lead-btn--ghost {
   background: transparent;
   color: #64748b;
   border: 1.5px solid #e2e8f0;
}

.lead-btn--ghost:hover {
   background: #f8fafc;
   color: #334155;
}

/* ── Modal Transition ── */
.lead-modal-fade-enter-active,
.lead-modal-fade-leave-active {
   transition: opacity 0.2s ease;
}

.lead-modal-fade-enter-from,
.lead-modal-fade-leave-to {
   opacity: 0;
}

/* ── Linked status badges ── */
.auth-synced-badge {
   display: inline-flex;
   align-items: center;
   gap: 6px;
   padding: 4px 10px;
   background: #ecfdf5;
   color: #059669;
   border: 1px solid #a7f3d0;
   border-radius: 14px;
   font-size: 0.8125rem;
   font-weight: 600;
   white-space: nowrap;
}

.auth-synced-badge i {
   font-size: 0.78rem;
}

.auth-linked-badge {
   display: inline-flex;
   align-items: center;
   gap: 6px;
   padding: 4px 10px;
   background: #eef2ff;
   color: #4f46e5;
   border: 1px solid #c7d2fe;
   border-radius: 14px;
   font-size: 0.8125rem;
   font-weight: 600;
   white-space: nowrap;
}

.auth-linked-badge i {
   font-size: 0.78rem;
   color: #6366f1;
}

.lead-linked-badge {
   display: inline-flex;
   align-items: center;
   gap: 6px;
   padding: 4px 10px;
   background: #ecfdf5;
   color: #059669;
   border: 1px solid #a7f3d0;
   border-radius: 14px;
   font-size: 0.8125rem;
   font-weight: 600;
   white-space: nowrap;
}

.lead-linked-badge i {
   font-size: 0.78rem;
}

.lead-marked-badge {
   display: inline-flex;
   align-items: center;
   gap: 6px;
   padding: 4px 10px;
   background: #eff6ff;
   color: #2563eb;
   border: 1px solid #bfdbfe;
   border-radius: 14px;
   font-size: 0.8125rem;
   font-weight: 600;
   white-space: nowrap;
}

.lead-marked-badge i {
   font-size: 0.78rem;
}

.lead-unlinked-badge {
   display: inline-flex;
   align-items: center;
   gap: 6px;
   padding: 4px 10px;
   background: #fef2f2;
   color: #dc2626;
   border: 1px solid #fecaca;
   border-radius: 14px;
   font-size: 0.8125rem;
   font-weight: 600;
   white-space: nowrap;
}

.lead-unlinked-badge i {
   font-size: 0.78rem;
}

.lead-test-badge {
   display: inline-flex;
   align-items: center;
   gap: 6px;
   padding: 4px 10px;
   background: #fff7ed;
   color: #ea580c;
   border: 1px solid #ffedd5;
   border-radius: 14px;
   font-size: 0.8125rem;
   font-weight: 600;
   white-space: nowrap;
   text-transform: uppercase;
   vertical-align: middle;
}

.lead-no-bdm-badge {
   display: inline-flex;
   align-items: center;
   gap: 6px;
   padding: 4px 10px;
   background: #fef2f2;
   color: #dc2626;
   border: 1px solid #fee2e2;
   border-radius: 14px;
   font-size: 0.8125rem;
   font-weight: 600;
   white-space: nowrap;
   text-transform: uppercase;
   vertical-align: middle;
}

.btn-svg-icon:hover i {
   color: #fff !important;
}

.btn-action-link,
.btn-action-unlink,
.btn-action-unmark {
   width: 36px;
   height: 36px;
   border-radius: 50% !important;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   padding: 0;
   cursor: pointer;
   transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease, color 0.15s ease;
   outline: none;
   border: none;
}

.btn-action-link {
   background-color: #eff6ff;
   color: #3b82f6;
}

.btn-action-link i {
   color: #3b82f6;
   transition: color 0.15s ease;
}

.btn-action-link:hover:not(:disabled) {
   background-color: #3b82f6;
   color: #fff;
   transform: translateY(-1px);
   box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.btn-action-link:hover:not(:disabled) i {
   color: #fff !important;
}

.btn-action-unlink {
   background-color: #fef2f2;
   color: #ef4444;
}

.btn-action-unlink i {
   color: #ef4444;
   transition: color 0.15s ease;
}

.btn-action-unlink:hover:not(:disabled) {
   background-color: #ef4444;
   color: #fff;
   transform: translateY(-1px);
   box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
}

.btn-action-unlink:hover:not(:disabled) i {
   color: #fff !important;
}

.btn-action-unmark {
   background-color: #eff6ff;
   color: #3b82f6;
}

.btn-action-unmark i {
   color: #3b82f6;
   transition: color 0.15s ease;
}

.btn-action-unmark:hover:not(:disabled) {
   background-color: #3b82f6;
   color: #fff;
   transform: translateY(-1px);
   box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.btn-action-unmark:hover:not(:disabled) i {
   color: #fff !important;
}

/* Custom checkbox input style */
.custom-checkbox-input {
   display: none;
}
.custom-checkbox-input + .custom-checkbox {
   width: 18px;
   height: 18px;
   border: 2px solid #dee2e6;
   border-radius: 4px;
   display: inline-block;
   position: relative;
   cursor: pointer;
   transition: all 0.2s ease;
   background-color: #fff;
}
.custom-checkbox-input:checked + .custom-checkbox {
   background-color: #00A0C1;
   border-color: #00A0C1;
}
.custom-checkbox-input:checked + .custom-checkbox::after {
   content: '\f00c';
   font-family: 'Font Awesome 6 Free';
   font-weight: 900;
   font-size: 10px;
   color: #fff;
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
}
.cursor-pointer {
   cursor: pointer;
}
.select-none {
   user-select: none;
}

/* Custom premium switch styling */
.custom-switch-input:checked {
   background-color: #00A0C1 !important;
   border-color: #00A0C1 !important;
}
.custom-switch-input {
   border-color: #dee2e6 !important;
   transition: transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}
.custom-switch-input:hover {
   transform: scale(1.05);
}
.custom-switch-input:focus {
   box-shadow: 0 0 0 0.25rem rgba(0, 160, 193, 0.25) !important;
}

/* Custom filter dropdown button */
.custom-filter-dropdown-btn {
   background-color: #fff !important;
   border: 1px solid #dee2e6 !important;
   color: #495057 !important;
   transition: all 0.2s ease;
}
.custom-filter-dropdown-btn:hover,
.custom-filter-dropdown-btn:focus,
.custom-filter-dropdown-btn[aria-expanded="true"] {
   border-color: #00A0C1 !important;
   background-color: #f8f9fa !important;
   color: #00A0C1 !important;
}

/* Premium Classification Tabs CSS */
.accounts-tabs-wrapper {
   border-bottom: 2px solid #e9ecef;
   margin-bottom: 1.5rem;
   padding-top: 0.5rem;
}

.accounts-tabs {
   display: flex;
   gap: 2rem;
}

.accounts-tab {
   background: none;
   border: none;
   padding: 0.75rem 0.5rem;
   font-size: 1rem;
   font-weight: 600;
   color: #6c757d;
   cursor: pointer;
   position: relative;
   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
   display: inline-flex;
   align-items: center;
   outline: none;
}

.accounts-tab i {
   font-size: 1.1rem;
   transition: transform 0.3s ease;
}

.accounts-tab:hover {
   color: #00A0C1;
}

.accounts-tab:hover i {
   transform: translateY(-2px);
}

.accounts-tab.active {
   color: #00A0C1;
}

.accounts-tab::after {
   content: '';
   position: absolute;
   bottom: -2px;
   left: 0;
   width: 100%;
   height: 3px;
   background-color: #00A0C1;
   transform: scaleX(0);
   transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
   transform-origin: center;
   border-top-left-radius: 3px;
   border-top-right-radius: 3px;
}

.accounts-tab.active::after {
   transform: scaleX(1);
}

/* Page Header Styles */
.ms-page-header {
   margin-bottom: 24px;
   padding: 20px 24px;
   background: linear-gradient(135deg, #ffffff 0%, #f4f9fb 100%);
   border: 1px solid rgba(0, 130, 152, 0.15);
   border-left: 5px solid #008298;
   border-radius: 12px;
   box-shadow: 0 4px 18px rgba(0, 78, 90, 0.05);
}

.ms-page-header__content {
   display: flex;
   align-items: center;
   gap: 16px;
}

.ms-page-header__icon {
   width: 44px;
   height: 44px;
   border-radius: 10px;
   background: rgba(0, 130, 152, 0.08);
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: 1.15rem;
   color: #008298;
}

.ms-page-header__title {
   font-size: 1.45rem;
   font-weight: 800;
   color: #00363f;
   margin: 0;
   letter-spacing: -0.3px;
}

.ms-page-header__breadcrumb {
   font-size: 0.76rem;
   color: #557d84;
   font-weight: 700;
   text-transform: uppercase;
   letter-spacing: 0.8px;
   margin-bottom: 4px;
}

.ms-breadcrumb-sep {
   margin: 0 6px;
   color: rgba(0, 130, 152, 0.3);
}
</style>